import {
  InitialState,
  NotificationCartActions,
  NotificationCartState,
  SHOW_NOTIFICATION_SUCCESS,
  SHOW_NOTIFICATION_ERROR,
  HIDE_NOTIFICATION,
  TypeNotification,
} from './types'

const NotificationCartReducer = (
  state: NotificationCartState = InitialState,
  action: NotificationCartActions
): NotificationCartState => {
  switch (action.type) {
    case SHOW_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        open: true,
        type: TypeNotification.OK,
        selectedItem: action.payload,
      }
    }
    case SHOW_NOTIFICATION_ERROR: {
      return {
        ...state,
        open: true,
        type: TypeNotification.ERROR,
        selectedItem: null,
      }
    }
    case HIDE_NOTIFICATION: {
      return {
        ...state,
        open: false,
        type: '',
        selectedItem: null,
      }
    }
    default:
      return state
  }
}

export default NotificationCartReducer
